export const SIGN_IN_SAGA = 'SIGN_IN_SAGA';
export const SIGN_IN_SUCCESS = 'SIGN_IN_SUCCESS';
export const SIGN_IN_UNAUTHORIZED = 'SIGN_IN_UNAUTHORIZED';
export const SIGN_IN_INTERNAL_SERVER_ERROR = 'SIGN_IN_INTERNAL_SERVER_ERROR';
export const SIGN_IN_PARTIAL_SUCCESS_EMAIL_NOT_VERIFIED =
  'SIGN_IN_PARTIAL_SUCCESS_EMAIL_NOT_VERIFIED';
export const SIGN_IN_VERIFICATION_EMAIL_FAILED_TO_SEND =
  'SIGN_IN_VERIFICATION_EMAIL_FAILED_TO_SEND';
export const SIGN_IN_UNKNOWN_ERROR = 'SIGN_IN_UNKNOWN_ERROR';
export const SIGN_OUT_SAGA = 'SIGN_OUT_SAGA';
